import type { ReactNode } from 'react';
import { UserGoal } from 'src/common/enums';
export enum CopyType {
  FREE = 'FREE',
  PREMIUM = 'PREMIUM',
}
export type ModalCopy = Record<UserGoal, {
  title: ReactNode;
  subtitle: ReactNode;
}>;
const DEFAULT_SUBTITLE = () => <>
    <span>25% off</span> annual subscriptions
  </>;
const NO_GOAL_COPY = () => <>
    Level Up Your Learning: <span>25% OFF</span> Annual Subscriptions
  </>;
const GET_JOB_CYBER_COPY = 'Secure the skills for your dream cyber job';
const MASTER_NEW_SKILL_COPY = 'Invest in the skills that shape your future';
const JUST_LOOKING_AROUND_COPY = 'Level up your learning';
const TRAIN_TEAM_COPY = 'Sharpen your skills, lead with confidence';
const UPSKILL_FIELD_COPY = 'Master the skills that set you apart';
const LEARN_SCHOOL_COPY = 'Learn cybersecurity from the ground up';
const EVALUTE_THM_COPY = 'Discover the platform that powers team growth';
export const MODAL_COPIES: Record<CopyType, ModalCopy> = {
  [CopyType.FREE]: {
    [UserGoal.GET_JOB_CYBER]: {
      title: GET_JOB_CYBER_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.MASTER_NEW_SKILL]: {
      title: MASTER_NEW_SKILL_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.JUST_LOOKING_AROUND]: {
      title: JUST_LOOKING_AROUND_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.TRAIN_TEAM]: {
      title: TRAIN_TEAM_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.UPSKILL_FIELD]: {
      title: UPSKILL_FIELD_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.LEARN_SCHOOL]: {
      title: LEARN_SCHOOL_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.EVALUTE_THM]: {
      title: EVALUTE_THM_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.SWITCH_CAREERS]: {
      title: NO_GOAL_COPY(),
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.GET_PROMOTION]: {
      title: NO_GOAL_COPY(),
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.PREPARE_CERTIFICATION]: {
      title: NO_GOAL_COPY(),
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.GAIN_FUNDAMENTAL_SKILLS]: {
      title: NO_GOAL_COPY(),
      subtitle: DEFAULT_SUBTITLE()
    }
  },
  [CopyType.PREMIUM]: {
    [UserGoal.GET_JOB_CYBER]: {
      title: GET_JOB_CYBER_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.MASTER_NEW_SKILL]: {
      title: MASTER_NEW_SKILL_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.JUST_LOOKING_AROUND]: {
      title: JUST_LOOKING_AROUND_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.TRAIN_TEAM]: {
      title: TRAIN_TEAM_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.UPSKILL_FIELD]: {
      title: UPSKILL_FIELD_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.LEARN_SCHOOL]: {
      title: LEARN_SCHOOL_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.EVALUTE_THM]: {
      title: EVALUTE_THM_COPY,
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.SWITCH_CAREERS]: {
      title: NO_GOAL_COPY(),
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.GET_PROMOTION]: {
      title: NO_GOAL_COPY(),
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.PREPARE_CERTIFICATION]: {
      title: NO_GOAL_COPY(),
      subtitle: DEFAULT_SUBTITLE()
    },
    [UserGoal.GAIN_FUNDAMENTAL_SKILLS]: {
      title: NO_GOAL_COPY(),
      subtitle: DEFAULT_SUBTITLE()
    }
  }
};
export const getModalCopy = (type: CopyType, goal?: string) => {
  if (!goal) {
    return {
      title: NO_GOAL_COPY(),
      subtitle: DEFAULT_SUBTITLE()
    };
  }
  return MODAL_COPIES[type][goal as UserGoal];
};